import { ENV_CONFIG } from './env.config'

export const environment = {
  isProduction: false,
  isStaging: false,
  isTest: true,
  isDevelopment: false,
  // doesn't work with hostname :-(
  // TODO: allow test.plan.seetaltixi.ch to access
  // gmaAPIKey: 'AIzaSyCpAAsTH1CLlk0S0grjjA3-wgYqjcX7IkA',
  // gmaAPIKey: process.env['GOOGLE_MAPS_API_KEY'] ?? '',
  // gmaAPIKey: process.env['GOOGLE_MAPS_API_KEY'] ?? '',
  // gmaApiUrl: 'https://maps.googleapis.com/maps/api/js',
  sessionTimeout: 2 * 3600,  // timeout in seconds
  // apiUrl: 'https://test.plan.seetaltixi.ch/api/v1',
  // relative -> same origin as the served app, nginx proxies /api (no CORS)
  apiUrl: '/api/v1',
  gmaAPIKey: 'AIzaSyBqQTzISWkpBL9OdKg00onZFRlLvc8yAYE',
  // sessionTimeout: ENV_CONFIG.sessionTimeout,
  // apiUrl: ENV_CONFIG.ApiUrl,
  // gmaAPIKey: ENV_CONFIG.gmaAPIKey,
  gmaApiUrl: 'https://maps.googleapis.com/maps/api/js',
  appName: 'Tixiplan©',
  appVersion: '1.7.11',
  appVersionDate: '19.08.2026',
  appStage: 'test',
  supportEmail: 'support@rabbit-it.ch',
  supportPhone: '+41 41 562 08 28',
}
